'use client'

import { useCallback } from 'react'
import { useSearchParams } from 'next/navigation'

type ParamInput = string | readonly string[] | null | undefined

export function useUrlWithQuery() {
  const searchParams = useSearchParams()

  const buildUrl = useCallback(
    (path: string, overrides?: Record<string, ParamInput>) => {
      const next = new URLSearchParams()

      if (searchParams) {
        for (const key of Array.from(searchParams.keys())) {
          const vals = searchParams.getAll(key)
          for (const v of vals) next.append(key, v)
        }
      }

      if (overrides) {
        for (const [k, v] of Object.entries(overrides)) {
          next.delete(k)
          if (v == null) continue

          const values: string[] = Array.isArray(v)
            ? (v as readonly string[]).map(String)
            : [String(v)]

          for (const item of values) next.append(k, item)
        }
      }

      const s = next.toString()
      return s ? `${path}?${s}` : path
    },
    [searchParams],
  )

  return { buildUrl }
}
